import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useDropzone } from 'react-dropzone';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Image,
  useToast,
} from '@chakra-ui/react';
import SplashService from '../../services/splashService';

const SplashScreen = () => {
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const toast = useToast();
  const queryClient = useQueryClient();

  const onDrop = (acceptedFiles) => {
    setFile(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const mutation = useMutation(
    (newSplash) => SplashService.create(newSplash),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('splashscreens');
        toast({
          title: 'Splash screen created.',
          description: 'The splash screen has been created successfully.',
          status: 'success',
          duration: 9000,
          isClosable: true,
        });
      },
      onError: (error) => {
        toast({
          title: 'An error occurred.',
          description: error.response?.data?.message || 'Something went wrong.',
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) {
      toast({
        title: 'No file selected.',
        description: 'Please select a file to upload.',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
      return;
    }
    mutation.mutate({ name, description, coverphoto: file });
  };

  return (
    <Box maxW="md" mx="auto" p={4}>
      <form onSubmit={handleSubmit}>
        <FormControl isRequired>
          <FormLabel>Name</FormLabel>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </FormControl>
        <FormControl isRequired mt={4}>
          <FormLabel>Description</FormLabel>
          <Textarea value={description} onChange={(e) => setDescription(e.target.value)} />
        </FormControl>
        <FormControl isRequired mt={4}>
          <FormLabel>Cover Photo</FormLabel>
          <Box {...getRootProps()} border="2px dashed" p={4} textAlign="center" cursor="pointer">
            <input {...getInputProps()} />
            {file ? (
              <Image src={URL.createObjectURL(file)} alt="Cover Photo" maxH="200px" mx="auto" />
            ) : (
              <p>Drag 'n' drop an image here, or click to select one</p>
            )}
          </Box>
        </FormControl>
        <Button mt={4} colorScheme="teal" type="submit" isLoading={mutation.isLoading}>
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default SplashScreen;
